import template from './land-category.jade';
import landCategoryTypes from '../../../enums/land-category-type';

export default angular
  .module('cian.addForm.aboutLandLandCategory', [])
  .directive('cianAfAboutLandLandCategory', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller() {
      'ngInject';

      this.items = landCategoryTypes;
    },
    controllerAs: 'landCategory',
    template,
  })).name;
